export function faqPage() {
    document.querySelectorAll('.question-click').forEach(link => {
        link.addEventListener('click', () => {
            const questionId = link.getAttribute('href').replace('#', '')
            document.getElementById(questionId).setAttribute('open', '')
        })
    })
}
